var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"rangepick",staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$t('src/plugins/daterangeinput.7335')}})}
var staticRenderFns = []

export { render, staticRenderFns }